import { translate } from '@wix/wixstores-client-core';
var ProductPriceBreakdown = /** @class */ (function () {
    function ProductPriceBreakdown(siteStore, translationsMap, taxDisclaimerKeys) {
        this.siteStore = siteStore;
        this.translationsMap = translationsMap;
        this.taxDisclaimerKeys = taxDisclaimerKeys;
    }
    Object.defineProperty(ProductPriceBreakdown.prototype, "taxDisclaimer", {
        get: function () {
            if (!this.siteStore.taxName) {
                return undefined;
            }
            if (this.siteStore.priceSettings.taxOnProduct) {
                return translate(this.translationsMap[this.taxDisclaimerKeys.includedPattern], {
                    taxOrVAT: this.siteStore.taxName,
                    included: this.translationsMap[this.taxDisclaimerKeys.includedKey],
                });
            }
            return translate(this.translationsMap[this.taxDisclaimerKeys.excludedPattern], {
                taxOrVAT: this.siteStore.taxName,
                excluding: this.translationsMap[this.taxDisclaimerKeys.excludedKey],
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductPriceBreakdown.prototype, "shouldShowTaxDisclaimer", {
        get: function () {
            return this.siteStore.priceSettings.showTaxDisclaimer && !!this.siteStore.taxName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductPriceBreakdown.prototype, "shippingDisclaimer", {
        get: function () {
            return this.siteStore.priceSettings.shippingDisclaimer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductPriceBreakdown.prototype, "priceBreakdownBIParam", {
        get: function () {
            var _a;
            var showShipping = (_a = this.siteStore.priceSettings.shippingDisclaimer) === null || _a === void 0 ? void 0 : _a.show;
            var showTax = this.shouldShowTaxDisclaimer;
            if (!showTax && !showShipping) {
                return undefined;
            }
            var params = [];
            showTax && params.push('tax');
            showShipping && params.push('shipping');
            return params.join(', ');
        },
        enumerable: false,
        configurable: true
    });
    return ProductPriceBreakdown;
}());
export { ProductPriceBreakdown };
//# sourceMappingURL=ProductPriceBreakdown.js.map